var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.use
    ? _c(
        "span",
        _vm._b(
          { staticClass: "jade-icon", class: _vm.computedClassList },
          "span",
          _vm.$attrs,
          false
        ),
        [_c(_vm.computedDynamicIcon, { tag: "component" })],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }